import React from 'react';

type AddButtonIconProps = {
  mode?: 'light' | 'dark';
};

export const AddButtonIcon = ({ mode = 'light' }: AddButtonIconProps) => {
  const isDark = mode === 'dark';

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
      <rect
        x="2"
        y="2"
        width="36"
        height="36"
        rx="18"
        fill={isDark ? 'white' : 'black'}
        fillOpacity="0.12"
      />
      <path
        d="M27 21H21V27H19V21H13V19H19V13H21V19H27V21Z"
        fill={isDark ? 'white' : '#231F29'}
        fillOpacity="0.56"
      />
    </svg>
  );
};
